var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { on: { click: _vm.clickItem } }, [
    _c("div", {
      directives: [
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: {
            callback: _vm.visibilityChanged,
            once: true,
          },
          expression:
            "{\n\t\t\tcallback: visibilityChanged,\n\t\t\tonce: true,\n\t\t}",
        },
      ],
      staticClass: "imageHolder privateData",
      style: _vm.style,
    }),
    _vm._v(" "),
    _vm.hasRemove
      ? _c("div", { staticClass: "removeIcon", on: { click: _vm.remove } }, [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("\n\t\t\tclose\n\t\t"),
          ]),
        ])
      : !_vm.showIncludedStatus
      ? _c("div", { staticClass: "statusIcon" }, [
          _vm.photoModel._error
            ? _c("i", { staticClass: "material-icons statusFailed" }, [
                _vm._v("\n\t\t\twarning\n\t\t"),
              ])
            : _vm.completed
            ? _c("i", { staticClass: "material-icons statusCompleted" }, [
                _vm._v("\n\t\t\tcloud_done\n\t\t"),
              ])
            : _vm.isVisible
            ? _c("i", {
                staticClass: "fa fa-spinner-third animationSpin statusBusy",
              })
            : _vm._e(),
        ])
      : _vm.isIncluded
      ? _c("div", { staticClass: "statusIcon" }, [
          _c("i", { staticClass: "material-icons statusUploaded" }, [
            _vm._v("\n\t\t\tcheck\n\t\t"),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }